import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import FullWidthHeaderAdvanced from "@components/BasicComponents/FullWidthHeader/FullWidthHeaderAdvanced"
import Separator from "@components/CustomTypography/Separator/Separator"
import SocialResponsibilityContactFormSection from "@components/Pages/SocialResponsibility/SocialResponsibilityForm/SocialResponsibilityContactFormSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import ExpertiseJson from "@jsons/expertise.json"
import ExpertiseIntro from "@pages/Expertise/ExpertiseIntro/ExpertiseIntro"
import ExpertiseWorkshop from "@pages/Expertise/ExpertiseWorkshop/ExpertiseWorkshop"
import React from "react"

type Props = {}

const expertise = (props: Props): JSX.Element => {
	const pageData = getTranslatedPageData(ExpertiseJson, true, true)
	const ExpertiseSections = getValueOrThrow(pageData.AdvancedSideAsset)
	const hero = getValueOrThrow(pageData.heroData?.[0])

	return (
		<>
			<HeadMeta
				meta={pageData.metaData}
				customPath="/about-us/expertise"
			/>

			<FullWidthHeader data={hero} position={"left"} size={"L"} />
			<ExpertiseIntro data={ExpertiseSections[0]} />

			<Separator size={128} />
			{/* <ExpertiseCustomerCards
				data={ExpertiseSections[1]}
				stories={stories}
			/> */}

			{/* <ExpertiseSecurity data={ExpertiseSections[2]} /> */}

			{/* <ExpertiseStudio data={ExpertiseSections[3]} /> */}

			{/* <UseCasesSlider data={ExpertiseSections[7]} /> */}

			<ExpertiseWorkshop
				data={[ExpertiseSections[4], ExpertiseSections[5]]}
			/>

			<SocialResponsibilityContactFormSection />
			{/* <ExpertiseCallToAction data={ExpertiseSections[6]} /> */}
		</>
	)
}

export default expertise
